module.exports = __webpack_public_path__ + "img/28.f3ac16ea.jpg";